<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
      spinner="bar-fade-scale" />
    <v-snackbar v-model="showsnackbar" color="#005f32" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading">TARGET DETAILS</span> -->
          <v-spacer></v-spacer>
          <v-flex xs12 align-self-center pt-2>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span style="font-family: kumbhRegular; font-size: 14px">*Select the options to filter the
                  results</span>
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2>
                <v-select clearable v-model="financialYear" :items="financialYears" item-text="name" item-value="name"
                  label="Financial Year" required outlined dense hide-details></v-select>
              </v-flex>
              <v-flex xl3 lg3 md3 sm6 xs12 pr-2 pt-2 pt-lg-0 pt-sm-0 pt-md-0>
                <v-text-field v-model="keyword" outlined dense hide-details clearable label="Search Employee">
                </v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xl3 lg3 md3 sm12 xs12 pt-2 pt-lg-0 pt-sm-2 pt-md-0 align-self-center class="d-flex justify-end">
                <v-btn style="font-family: kumbhBold;" dark color="#005f32" @click="downloadExcel" :disabled="data.length === 0">
                  <v-icon left>mdi-file-excel</v-icon>
                  Download Excel
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-start px-4 v-if="data.length > 0">
          <v-flex xs12 pt-3>
            <v-simple-table class="align-center">
              <template v-slot:default>
                <thead style="background-color: #005f32">
                  <tr>

                    <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                      Employee Id
                    </th>
                    <th style="
                    font-size: 15px;
                    color: #ffffff;
                    font-family: kumbhRegular;
                  
                  " class="text-left">
                      Name

                    </th>
                    <th style="
                    font-size: 15px;
                    color: #ffffff;
                    font-family: kumbhRegular;
                  " class="text-left">
                      Total Targets
                    </th>
                    <th style="
                 font-size: 15px;
                 color: #ffffff;
                 font-family: kumbhRegular;
               " class="text-left">
                      Met Count


                    </th>

                    <th style="
                        font-size: 15px;
                        color: #ffffff;
                        font-family: kumbhRegular;
                      " class="text-left">
                      Not Met Count

                    </th>




                    <th style="
              font-size: 15px;
              color: #ffffff;
              font-family: kumbhRegular;
            " class="text-left">
                      Delayed Met Count

                    </th>
                    <th style="
              font-size: 15px;
              color: #ffffff;
              font-family: kumbhRegular;
            " class="text-left">
                      Total Score
                    </th>
                    <th style="
              font-size: 15px;
              color: #ffffff;
              font-family: kumbhRegular;
            " class="text-left">
                      Total Weightage

                    </th>
                    <th style="
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhRegular;
" class="text-left">
                      Attachments
                    </th>
                    <th style="
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhRegular;
" class="text-left">
                      View
                    </th>
                  </tr>
                </thead>
                <tbody class="align-center">
                  <template>
                    <tr class=" text-left align-center" style="cursor:pointer;" v-for="(item) in data" :key="item._id">

                      <td style="text-align:justify">
                        <span v-if="item.employeeId" class="" style="font-family: kumbhMedium; cursor: pointer">
                          {{ item.employeeId }}
                        </span>
                      </td>

                      <td>
                        <span v-if="item.name" class="" style="font-family: kumbhMedium">{{
                          item.name }}</span>
                      </td>

                      <td>
                        <span class="" style="font-family: kumbhMedium">{{ item.totalTargetCount || 0 }}</span>
                      </td>

                      <td>
                        <span class="" style="font-family: kumbhMedium">{{ item.metCount }}</span>
                      </td>

                      <td>
                        <span class="" style="font-family: kumbhMedium">{{ item.notMetCount }}</span>
                      </td>
                      <td>
                        <span class="" style="font-family: kumbhMedium">{{ item.delayedMetCount }}</span>
                      </td>
                      <td>
                        <span class="" style="font-family: kumbhMedium">{{ item.totalScore }}</span>
                      </td>
                      <td>
                        <span class="" style="font-family: kumbhMedium">{{ item.totalWeightage }}</span>
                      </td>
                      <td>
                        <v-btn icon small color="#005f32" @click="openAttachmentDialog(item)">
                          <v-icon>mdi-paperclip</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <v-btn icon small color="#005f32" @click="redirectToViewPage(item)">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Data found!</span>
          </v-flex>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages" :total-visible="7"
            v-model="currentPage" color="#005f32"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <!-- Attachment Dialog -->
    <v-dialog v-model="attachmentDialog" persistent max-width="500px">
      <v-card>
        <v-form ref="attachmentForm">
          <v-card-title>
            <span class="headline">Upload Support Document</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 pt-6>
                <v-icon x-large color="#408BFF" @click="$refs.attachmentFileInput.click()">mdi-cloud-upload</v-icon>
              </v-flex>
              <v-flex xs12 pb-5>
                <span class="con4">Upload Document</span>
                &nbsp;
                <input v-show="false" ref="attachmentFileInput" type="file" @change="onAttachmentFileChange" />
              </v-flex>
              <v-flex xs12 py-3 text-left>
                <v-chip v-if="attachmentFile" close dark color="green" @click:close="removeAttachmentFile"
                  style="margin-right: 6px;">
                  {{ attachmentFile.name }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeAttachmentDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="uploadAttachment" :disabled="!attachmentFile">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    keyword: "",
    showsnackbar: false,
    ServerError: false,
    msg: null,
    appLoading: false,
    g: false,
    attachmentDialog: false,
    attachmentFile: null,
    selectedEmployeeId: null,
    financialYear: "",
    financialYears: [],
    rules: {
      required: (value) => !!value || "Required.",
    },
    data: [],
    pages: 0,
    currentPage: 1,
    totalData: 0,
  }),

  mounted() {
    this.getData();
    this.generateFinancialYears();
  },
  watch: {
    currentPage() {
      this.getData();
    },
    keyword() {
      this.getData();
      this.currentPage = 1
    },
    financialYear() {
      this.getData();
      this.currentPage = 1
    },
  },
  methods: {
    redirectToViewPage(item) {
      this.$router.push(
        `/Targets/teamTarget?employeeId=${item._id}`
      );
    },
    generateFinancialYears() {
      const startYear = 2000;
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth();

      // If the current month is before April (0-based index), it's still the previous financial year
      const endYear = currentMonth < 3 ? currentYear : currentYear + 1;

      for (let year = startYear; year <= endYear; year++) {
        this.financialYears.push(`${year}-${year + 1}`);
      }

      // Set default financial year to the current financial year
      const defaultStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
      this.financialYear = this.$route.query.financialYear || `${defaultStartYear}-${defaultStartYear + 1}`;
    },
    openAttachmentDialog(item) {
      this.selectedEmployeeId = item.targetId;
      this.attachmentFile = null;
      this.attachmentDialog = true;
    },

    closeAttachmentDialog() {
      this.attachmentDialog = false;
      this.attachmentFile = null;
      this.selectedEmployeeId = null;
    },

    onAttachmentFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.attachmentFile = file;
      }
    },

    removeAttachmentFile() {
      this.attachmentFile = null;
      if (this.$refs.attachmentFileInput) {
        this.$refs.attachmentFileInput.value = '';
      }
    },

    async uploadAttachment() {
      if (!this.attachmentFile) {
        this.msg = "Please select a file";
        this.showsnackbar = true;
        return;
      }

      const formData = new FormData();
      formData.append('supportDocument', this.attachmentFile);
      formData.append('targetId', this.selectedEmployeeId);

      this.appLoading = true;
      try {
        const res = await axios({
          url: `/employee/target/supportdocument/upload`,
          method: 'POST',
          headers: {
            "x-auth-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data"
          },
          data: formData
        });
        this.appLoading = false;
        this.attachmentDialog = false;
        this.msg = res.data.msg || "Document uploaded successfully";
        this.showsnackbar = true;
        this.attachmentFile = null;
        if (this.$refs.attachmentFileInput) {
          this.$refs.attachmentFileInput.value = '';
        }
      } catch (err) {
        this.appLoading = false;
        this.msg = (err.response && err.response.data && err.response.data.msg) || "Failed to upload document";
        this.showsnackbar = true;
      }
    },
    getData() {
      this.appLoading = true;
      const financialYearToPass = this.financialYear;
      axios({
        url: "/admin/reportingmanagers/employees/list/v1",
        method: "GET",
        params: {
          keyword: this.keyword,
          financialYear: financialYearToPass,
          page: this.currentPage,
          limit: 20,

        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.data = response.data.data;
          this.totalData = response.data.total;
          this.pages = Math.ceil(this.totalData / response.data.limit);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    downloadExcel() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/admin/reportingmanagers/employees/list/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          keyword: this.keyword,
          financialYear: this.financialYear,
        },
        responseType: "blob",
      })
        .then((response) => {
          this.appLoading = false;
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);

          const anchor = document.createElement("a");
          anchor.href = url;
          anchor.target = "_blank";
          anchor.download = `TargetDetails_${this.financialYear || 'All'}.xlsx`;

          anchor.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.tableHead {
  font-size: 15px;
  color: #ffffff;
  font-family: kumbhMedium;
}
</style>
